import * as React from 'react';
import { Tabs, Icon, Skeleton, Row, Col, Table } from 'antd';
import { CompanyService } from '../../../service/CompanyService';
import { CompanyNodeEdge } from '../Company/constants';
import { GraphqlQuery } from 'requestapijs';
import { Pagination } from 'sha-el-design';
import { hsnQuery } from './constants';
import { HsnNodeConnection, HsnInput } from '../../../schema';
import { AddHsn } from './AddHsn';
import { TSInput } from '../../common/TSInput';
import { UserNodeEdge } from '../../../components/user/constants';
import { checkAddPermission } from '../../helper';
import { UserService } from '../../../service/UserService';

export class Hsn extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: '1',
      selectedHsn: null,
      isViewActive: false,
      company: null,
      currentPage: 1,
      after: '',
      hsnCode: '',
      user: null,
    };
  }

  companyService = new CompanyService();
  userService = new UserService();

  componentDidMount() {
    this.companyService?.company$.subscribe((company) =>
      this.setState({ company }),
    );
    this.userService?.user$.subscribe((user) =>
      this.setState({ user: user?.user }),
    );
  }

  handleTabChange = (activeKey: string) => {
    if (activeKey === '1') {
      this.setState({ activeKey, selectedHsn: null });
      this.componentDidMount();
      return;
    }
    this.setState({ activeKey });
  };

  hsnColumn = () => [
    {
      title: 'HSN Code',
      dataIndex: 'node.hsnCode',
      key: 'hsnCode',
      render: (text, obj) => (
        <a
          onClick={() => {
            this.setState({ selectedHsn: obj.node, activeKey: '2' });
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: 'Min. Amt.',
      dataIndex: 'node.minValue',
      key: 'minValue',
    },
    {
      title: 'Max. Amt.',
      dataIndex: 'node.maxValue',
      key: 'maxValue',
    },
    {
      title: 'GST',
      dataIndex: 'node.gst',
      key: 'gst',
    },
  ];

  afterStack = [''];

  onPageChange = (next: boolean, after: string, nextPage: boolean) => {
    if (next && nextPage) {
      this.setState({ after, currentPage: this.state.currentPage + 1 });
      this.afterStack.push(after);
    } else if (!next && this.afterStack.length > 1) {
      this.afterStack.pop();
      this.setState({
        after: this.afterStack[this.afterStack.length - 1],
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  render() {
    if (!this.state.company) {
      return <Skeleton active />;
    }
    if (this.state.user && !checkAddPermission(this.state.user))
      return <h1>Access Denied</h1>;
    const {
      company: { id: companyId },
      after,
      currentPage,
      activeKey,
    } = this.state;
    const variables = { companyId, first: 20, after, activeKey };
    const { hsnCode } = this.state;
    return (
      <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange}>
        <Tabs.TabPane
          tab={
            <span>
              <Icon type="table" />
              List Hsn
            </span>
          }
          key="1"
          closable={false}
        >
          <Row>
            <Col span={8}>
              <TSInput
                error=""
                value={this.state.hsnCode}
                onChange={(e) => this.setState({ hsnCode: e.target.value })}
                name="hsnCode"
                type="text"
                addonBefore="Search Hsn"
                placeholder="Enter Code"
              />
            </Col>
          </Row>
          <GraphqlQuery
            queryString={hsnQuery}
            variables={hsnCode ? { ...variables, hsnCode } : variables}
            render={(
              response: { allHsns: HsnNodeConnection },
              error,
              loading,
            ) => {
              if (response && companyId) {
                return [
                  <Table
                    key="table"
                    dataSource={response.allHsns.edges}
                    columns={this.hsnColumn()}
                    rowKey={(obj) => obj.node?.id || ''}
                    pagination={false}
                  />,
                  <Pagination
                    key="pagination"
                    totalCount={0}
                    currentPage={currentPage}
                    batchSize={20}
                    cursorBasedPagination
                    onChange={(_p, _ps, next) =>
                      this.onPageChange(
                        next,
                        response.allHsns.pageInfo.endCursor,
                        response.allHsns.pageInfo.hasNextPage,
                      )
                    }
                    style={{ float: 'right' }}
                  />,
                ];
              }
              return <Skeleton active />;
            }}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <span>
              <Icon type="plus" />
              Add Hsn
            </span>
          }
          key="2"
        >
          <AddHsn
            hsn={this.state.selectedHsn}
            handleTabChange={this.handleTabChange}
          />
        </Tabs.TabPane>
      </Tabs>
    );
  }
}

interface State {
  activeKey: string;
  selectedHsn: HsnInput | null;
  isViewActive: boolean;
  company: CompanyNodeEdge | null;
  after: string;
  currentPage: number;
  hsnCode: string;
  user?: UserNodeEdge | null;
}

interface Props {}
